import { animate, style, transition, trigger } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, ViewEncapsulation } from '@angular/core';
import { ButtonDirective } from '@cf/shared/ui/button';
import { NgxTolgeeModule } from '@tolgee/ngx';
import { PwaInstallService } from '../../services';

@Component({
  selector: 'cf-pwa-install-prompt',
  standalone: true,
  imports: [CommonModule, NgxTolgeeModule, ButtonDirective],
  templateUrl: './pwa-install-prompt.component.html',
  animations: [
    trigger('slideFade', [
      transition(':enter', [
        style({ transform: 'translateY(25%)', opacity: 0 }),
        animate(
          '300ms cubic-bezier(0.25, 0.8, 0.25, 1)',
          style({ transform: 'translateY(0)', opacity: 1 }),
        ),
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({ transform: 'translateY(10%)', opacity: 0 })),
      ]),
    ]),
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class PwaInstallPromptComponent {
  protected readonly service = inject(PwaInstallService);

  prompt() {
    this.service.promptInstall();
  }

  dismiss() {
    this.service.skipForever();
  }
}
